import { AxiosError } from 'axios';
import axiosInterseptor from '../../utils/axiosInterseptor';
import { adaptPhotos } from '../../utils/catalogUtils';

export default class CatalogData {
  // Проверяет, нужно ли использовать режим filter
  static shouldUseFilterMode(filters?: string): boolean {
    if (!filters) return false;
    try {
      const parsedFilters = JSON.parse(filters);
      // Используем режим filter, если указаны комнаты, но нет дат бронирования
      return (
        parsedFilters?.rooms &&
        !parsedFilters?.booking &&
        !parsedFilters?.begin &&
        !parsedFilters?.end
      );
    } catch (e) {
      return false;
    }
  }

  // Получает страницу каталога
  static async getPage({
    page,
    cityId,
    order,
    filters,
    signal,
  }: {
    cityId: number;
    page: number;
    order?: string;
    filters?: string;
    signal?: AbortSignal;
  }) {
    const params: Record<string, any> = {
      order,
      filters,
      page,
    };

    // Определяем режим на основе фильтров
    // if (this.shouldUseFilterMode(filters)) {
    //  params.mode = 'filter';
    // params.mode = 'search';
    // } else {
    // params.mode = 'search';
    // }

    params.mode = 'search';

    try {
      let { data } = await axiosInterseptor.get(`/products/city/${cityId}`, {
        params,
        signal,
      });

      // Опционально: если в режиме filter мало результатов, пробуем search
      if (params.mode === 'filter' && data?.items?.length < 10) {
        const searchParams = { ...params, mode: 'search' };
        const searchResponse = await axiosInterseptor.get(`/products/city/${cityId}`, {
          params: searchParams,
          signal,
        });
        data = searchResponse.data;
      }
      if (data.data && Array.isArray(data.data)) {
        data.data = data.data.map((item: any) => ({
          ...item,
          photos: adaptPhotos(item.photos, data.meta, item.id),
        }));
      }
      return data;
    } catch (error: any) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.error &&
        error.response.data.error.details
      ) {
        throw new URIError(error.response.data.error.details);
      } else if (error.code === 'ERR_CANCELED') {
        throw new AxiosError('отмена', error.code);
      } else {
        throw new URIError('не удалось загрузить');
      }
    }
  }

  // Получает все элементы каталога
  static async getAll({
    cityId,
    order,
    filters,
    signal,
  }: {
    cityId: number;
    order?: string;
    filters?: string;
    signal?: AbortSignal;
  }) {
    const params: Record<string, any> = {
      order,
      filters,
    };

    // Определяем режим на основе фильтров
    if (this.shouldUseFilterMode(filters)) {
      params.mode = 'filter';
    } else {
      params.mode = 'search';
    }

    try {
      const { data } = await axiosInterseptor.get(`/products/city/${cityId}`, {
        params,
        signal,
      });

      if (data.data && Array.isArray(data.data)) {
        data.data = data.data.map((item: any) => ({
          ...item,
          photos: adaptPhotos(item.photos, data.meta, item.id),
        }));
      }
      return data;
    } catch (error: any) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.error &&
        error.response.data.error.details
      ) {
        throw new URIError(error.response.data.error.details);
      } else if (error.code === 'ERR_CANCELED') {
        throw new AxiosError('отмена', error.code);
      } else {
        throw new URIError('не удалось загрузить');
      }
    }
  }

  // Получает данные конкретной квартиры
  static async getApartament({
    productId,
    begin,
    end,
    cashback,
  }: {
    productId: string;
    begin?: string;
    end?: string;
    cashback?: boolean;
  }) {
    const params = {
      begin,
      end,
      cashback,
    };

    const { data } = await axiosInterseptor.get(`/products/product/${productId}`, {
      params,
    });

    data.photos = adaptPhotos(
      data.photos.photos,
      { photos_url: data.photos.url, photos_res: data.photos.res },
      data.id,
    );

    return data;
  }

  // Получает районы города
  static async getAreas({ cityId }: { cityId: number }) {
    try {
      const response = await axiosInterseptor.get(`/addreses/city/${cityId}/areas`, {});
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  // Получает координаты города
  static async getCityCoords({ cityId }: { cityId: number }) {
    try {
      const response = await axiosInterseptor.get(`/addreses/city/${cityId}/coords`, {});
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  // Проверка занятости квартиры
  static async checkBooking({
    productId,
    begin,
    end,
  }: {
    productId: string;
    begin?: string;
    end?: string;
  }) {
    const params: Record<string, any> = {
      product_id: productId,
      begin,
      end,
    };
    try {
      const response = await axiosInterseptor.get(`/booking/check`, { params });
      const { data } = response;
      return data;
    } catch (error) {
      return error;
    }
  }

  // Получает избранные объявления
  static async getPublicFavorite(
    id: Array<number>,
    page: number,
    signal: AbortSignal,
    cityId?: number,
  ) {
    if (axiosInterseptor) {
      let url = `/products?mode=filter&products=${JSON.stringify(id)}&page=${page}`;
      if (cityId !== undefined) {
        url += `&filters={"city":${cityId}}`;
      }
      try {
        const response = await axiosInterseptor.get(url, { signal });
        const { data } = response;
        return data;
      } catch (error) {
        return error;
      }
    }
    return null;
  }
}
